import BasicLayout from '@/layouts/Basic';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';
const importEnv = require('./_import_' + process.env.NODE_ENV);
export default [
    {
        path: '/user/:userid/userCenter',
        component: BasicLayout,
        name: 'userCenterWork',
        children: [
            {
                path: '/',
                name: 'userCenter',
                meta: {
                },
                component: importEnv('User/index'),
                redirect: '/user/:userid/userCenter/order',
                children: [
                    {
                        path: 'rightsCenter',
                        name: 'rightsCenter',
                        meta: {},
                        component: importEnv('RightsCenter/index')
                    },
                    // coupon模块改版放到了order页面中，历史路由重定向到order页面
                    {
                        path: 'coupon',
                        redirect: '/user/:userid/userCenter/order',
                        name: 'couponManage',
                        meta: {
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('Coupon', () =>
                            import('../model/Coupon')
                        ),
                        component: importEnv('Coupon/index')
                    },
                    {
                        path: 'order',
                        name: 'orderManage',
                        meta: {
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('Order', () =>
                            import('../model/Order')
                        ),
                        component: importEnv('Order/index')
                    },
                    {
                        path: 'message',
                        name: 'messageCenter',
                        meta: {
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('Message', () =>
                            import('../model/Message')
                        ),
                        component: importEnv('Message/index')
                    },
                    {
                        path: 'aboutUs',
                        name: 'aboutUs',
                        component: importEnv('User/AboutUs')
                    }
                ]
            }
        ]
    },
    {
        path: '/userCenter',
        name: 'userCenterNoAuth',
        component: BasicLayout,
        children: [
            {
                path: '',
                meta: {
                },
                redirect: '/userCenter/aboutUs',
                component: importEnv('User/index'),
                children: [
                    {
                        path: 'message',
                        name: 'messageCenter',
                        meta: {
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('Message', () =>
                            import('../model/Message')
                        ),
                        component: importEnv('Message/index')
                    },
                    {
                        path: 'aboutUs',
                        name: 'aboutUsNoAuth',
                        meta: {
                            allowNotLogin: true
                        },
                        component: importEnv('User/AboutUs')
                    }
                ]
            }
        ]
    }
];
